import { render, staticRenderFns } from "./MenuDetail.vue?vue&type=template&id=671b5316"
import script from "./MenuDetail.vue?vue&type=script&lang=js"
export * from "./MenuDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports